exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".index__lightboxWrapper___3Dtat{background:hsla(0,0%,100%,.8);display:block;height:100%;left:0;overflow:scroll;position:fixed;top:0;width:100%;z-index:99999}.index__lightbox___T8OqW{display:block;margin:10px;position:relative;z-index:2}.index__wrapperClick___N5X53{background:none;display:block;height:100%;position:absolute;width:100%;z-index:1}", ""]);

// exports
exports.locals = {
	"lightboxWrapper": "index__lightboxWrapper___3Dtat",
	"lightbox": "index__lightbox___T8OqW",
	"wrapperClick": "index__wrapperClick___N5X53"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./app/components/lightbox/index.css
// module id = 313
// module chunks = 1